import {
  AGREEMENT_TYPE,
  IAgreementTemplatetAggregator,
} from 'services/templates/agreement-template/types';
import { ICustomSectionTemplateMutation } from 'services/templates/section-template/types';
import {
  IContractTemplateTreeItemForm,
  IDistributionMutation,
  IDistributionSharesMutation,
  IDistributionType,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { agreementTemplateFormToQuery } from './agreement-template/agreementTemplateFormToQuery';

interface ISeparateContractTreeItems {
  customSections: ICustomSectionTemplateMutation[];
  agreements: IAgreementTemplatetAggregator[];
  digitalDistribution?: IDistributionMutation;
  physicalDistribution?: IDistributionMutation;
  merchDistribution?: IDistributionMutation;
  channelDistribution?: IDistributionMutation;
}

export const getDistributionWithShares = (
  items: IContractTemplateTreeItemForm[],
  type: IDistributionType
): IDistributionMutation | undefined => {
  const itemsWithPosition = items.map((items, index) => ({
    ...items,
    position: index,
  }));

  const distributionItem = itemsWithPosition.find(item => item.type === type);

  let defaultShare = 0;

  const distributionShares =
    distributionItem?.children.reduce<IDistributionSharesMutation[]>(
      (
        acc: IDistributionSharesMutation[],
        item: IContractTemplateTreeItemForm
      ) => {
        if (
          item.type === TEMPLATE_TYPE.agreement &&
          item.content.distributionTemplateShares
        ) {
          if (
            item.content.type === AGREEMENT_TYPE.defaultShare &&
            item.content.distributionTemplateShares
          ) {
            defaultShare = item.content.distributionTemplateShares.percent ?? 0;
          }
          if (
            item.content.type === AGREEMENT_TYPE.shares &&
            !!item.content.distributionTemplateShares
          ) {
            const { id: salesChannelId, percent } =
              item.content.distributionTemplateShares;

            acc.push({
              salesChannelId,
              percent: percent ?? 0,
            });
          }
        }
        return acc;
      },
      []
    ) ?? [];

  if (!!distributionItem && distributionItem.type === type) {
    return {
      defaultShares: defaultShare,
      title: distributionItem.content,
      position: distributionItem.position,
      distributionTemplateShares: distributionShares,
    };
  }

  return undefined;
};

export const separateTemplateTreeItems = (
  items: IContractTemplateTreeItemForm[]
): ISeparateContractTreeItems => {
  const itemsWithPosition = items.map((items, index) => ({
    ...items,
    position: index,
  }));

  const agreements: IAgreementTemplatetAggregator[] = [];
  const customSections: ICustomSectionTemplateMutation[] = [];
  for (const item of itemsWithPosition) {
    if (item.type === TEMPLATE_TYPE.agreement) {
      agreements.push(
        agreementTemplateFormToQuery(item.content, item.position, true)
      );
    }
    if (item.type === TEMPLATE_TYPE.section) {
      customSections.push({
        ...separateTemplateTreeItems(item.children),
        title: item.content,
        position: item.position,
      });
    }
  }
  const digital = getDistributionWithShares(
    items,
    TEMPLATE_TYPE.digitalDistribution
  );
  const physical = getDistributionWithShares(
    items,
    TEMPLATE_TYPE.physicalDistribution
  );
  const merch = getDistributionWithShares(
    items,
    TEMPLATE_TYPE.merchDistribution
  );
  const youtube = getDistributionWithShares(
    items,
    TEMPLATE_TYPE.channelDistribution
  );
  return {
    customSections,
    agreements,
    ...(digital || physical || merch || youtube
      ? {
          digitalDistribution: digital,
          physicalDistribution: physical,
          merchDistribution: merch,
          channelDistribution: youtube,
        }
      : {}),
  };
};
